function validateCreateFormConfig(config) {
  if (!config) throw new Error("[createForm()] expects a configuration object");
  if (!config.id || !config.id.trim())
    throw new Error('[createForm()] expects a configuration object with a valid "id"');
  if (!config.initialValues) throw new Error('[createForm()] expects a configuration object with "initialValue"');
  if (config.initialErrors) {
    for (const fieldName of Object.keys(config.initialErrors)) {
      const fieldErrors = config.initialErrors[fieldName];
      if (fieldErrors) {
        for (const err of fieldErrors) {
          validateStringProperty(fieldName, "id", err.id, "initialError");
          validateStringProperty(fieldName, "field", err.field, "initialError");
          validateStringProperty(fieldName, "message", err.message, "initialError");
          validateNumberProperty(fieldName, "index", err.index);
          validateNumberProperty(fieldName, "priority", err.priority);
          if (err.field !== fieldName) {
            throw new Error(
              `[createForm()] received invalid initial errors for field "${fieldName}". The error "field" must match the assigned field, received "${err.field}"`
            );
          }
          validateUnknownKeys(fieldName, err, ["id", "field", "message", "priority", "index"], "initialError");
        }
      }
    }
  }
  if (config.fields) {
    for (const fieldName of Object.keys(config.fields)) {
      const field = config.fields[fieldName];
      if (field) {
        validateStringProperty(fieldName, "type", field.type, "field", true, ["field", "arrayField"]);
        validateStringProperty(fieldName, "status", field.status, "field", true, [
          "pristine",
          "indeterminate",
          "valid",
          "invalid"
        ]);
        validateBooleanProperty(fieldName, "disabled", field.disabled, true);
        validateBooleanProperty(fieldName, "required", field.required, true);
        validateBooleanProperty(fieldName, "visible", field.visible, true);
        validateUnknownKeys(
          fieldName,
          field,
          ["type", "status", "disabled", "required", "resetValue", "visible"],
          "field"
        );
      }
    }
  }
}
function validateStringProperty(fieldName, propName, propValue, ctx, allowUndefined = false, allowedValues = "all") {
  if (allowUndefined && propValue === void 0) return;
  let invalid = typeof propValue !== "string" || propValue.trim().length === 0;
  if (propValue && allowedValues !== "all") {
    if (!allowedValues.includes(propValue)) {
      invalid = true;
    }
  }
  if (invalid) {
    const validValues = allowedValues === "all" ? `a valid string` : `one of [${allowedValues}]`;
    throw new Error(
      ctx === "field" ? `[createForm()] received an invalid initial field configuration for the field "${fieldName}". The field "${propName}" must be ${validValues}, received "${propValue}"` : `[createForm()] received invalid initial errors for field "${fieldName}". The error "${propName}" must be ${validValues}, received "${propValue}"`
    );
  }
}
function validateBooleanProperty(fieldName, propName, propValue, allowUndefined = false) {
  if (allowUndefined && propValue === void 0) return;
  const invalid = typeof propValue !== "boolean";
  if (invalid) {
    throw new Error(
      `[createForm()] received an invalid initial field configuration for the field "${fieldName}". The field "${propName}" must be a valid string, received "${propValue}"`
    );
  }
}
function validateNumberProperty(fieldName, propName, propValue) {
  const invalid = propValue !== void 0 && (typeof propValue !== "number" || Number.isNaN(propValue));
  if (invalid) {
    throw new Error(
      `[createForm()] received invalid initial errors for field "${fieldName}". The error "${propName}" must be a valid number, received "${propValue}"`
    );
  }
}
function validateUnknownKeys(fieldName, source, expectedKeys, ctx) {
  const errKeys = Object.keys(source);
  const unknownKeys = errKeys.length > expectedKeys.length || errKeys.some((k) => !expectedKeys.includes(k));
  if (unknownKeys) {
    throw new Error(
      ctx === "field" ? `[createForm()] received an invalid initial field configuration for the field "${fieldName}". The error has unknown properties "${errKeys}"` : `[createForm()] received invalid initial errors for field "${fieldName}". The error has unknown properties "${errKeys}"`
    );
  }
}
export {
  validateCreateFormConfig
};
//# sourceMappingURL=validateCreateFormConfig.js.map
